import React from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import { CheckboxField } from "@components/inputs/desktop";

export const QuickBetFavoritesCheckBox = observer(
	function QuickBetFavoritesCheckBox() {
		const rootStore = useRootAppStore();

		if (!rootStore.userAuthStore.isLoggedIn) {
			return null;
		}

		return (
			<CheckboxField
				id="useUserFavorites"
				name="useUserFavorites"
				label="QUICK_PLAY.QUICK_BET.FAVORITES_OFFER"
				labelClassName="input--check__label u-type--sml"
			/>
		);
	}
);
